import { render, staticRenderFns } from "./AppExtension.vue?vue&type=template&id=0ba07adc&scoped=true"
import script from "./AppExtension.vue?vue&type=script&lang=js"
export * from "./AppExtension.vue?vue&type=script&lang=js"
import style0 from "./AppExtension.vue?vue&type=style&index=0&id=0ba07adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba07adc",
  null
  
)

export default component.exports